import request from '@/api/config/request'

export function getDadosEntidade() {
  return request({
    url: 'entidade',
    method: 'get'
  })
}

export function getDiarios(options = {}) {
  return request({
    url: 'diarios',
    method: 'get',
    params: options
  })
}

export function getSecoes() {
  return request({
    url: `secoes`,
    method: 'get'
  })
}

